var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('svg',{attrs:{"width":_vm.size,"height":_vm.size,"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M12 4V20M12 4L8 8M12 4L16 8","stroke":"#000000","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }